export enum GodziDropSoundTypeV2 {
  bgm = 'Godzi_BGM',
  godziRoar = 'Godzi_Efx_Godzi',
  silverEgg = 'Godzi_Efx_Egg_Silver',
  goldenEgg = 'Godzi_Efx_Egg_Golden',
  vipEgg = 'Godzi_Efx_Egg_Colored',
  enterPrize = 'Godzi_Efx_Feature',
  totalWin = 'Godzi_Efx_Total Win',
  betterLuck = 'Godzi_Efx_BetterLuck',
}
